//* 样式
import css from "../../../style/index.module.less";

export const useComposable = () => {
    //* vue插件
    const route = useRoute();
    const i18n = useI18n();

    //* 响应式变量
    const refs = {
        visible: ref<boolean>(false),
    };

    const options = [
        {
            name: i18n.t("GeneComparison"),
            icon: "gene",
            route: { name: "GeneticComparison", query: { id: route.params.id?.toString() } },
            visible: !(route.meta.route == "GeneticComparison"),
        },
        {
            name: i18n.t("DiseaseComparison"),
            icon: "disease",
            route: { name: "DiseasesComparison", query: { id: route.params.id?.toString() } },
            visible: !(route.meta.route == "DiseasesComparison"),
        },
        {
            name: i18n.t("ModalComparison"),
            icon: "model",
            route: { name: "ModelComparison", query: { id: route.params.id?.toString() } },
            visible: !(route.meta.route == "ModelComparison"),
        },
    ];

    //* 侦听器列表
    const watchs = {
        stopRouteWatch: watch(
            () => route.fullPath,
            () => {
                refs.visible.value = false;
            }
        ),
    };

    const binds = {
        tooltip: {
            "z-index": 999,
            "offsetX": 10,
            "offsetY": 10,
            "class-extra-name": css.tooltip,
        },
    };

    return { refs, options, watchs, binds };
};
